import React from "react";
import { connect } from "react-redux";
import { postStaffInfoList } from "../Actions/StaffManagementAPI";
import "react-datepicker/dist/react-datepicker.css";

class StaffManagementAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      StaffInfo: {
        // shipName: "",
        name: "",
        phone: "",
        mail: "",
        address: "",
        createdBy: "",
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
  }
  componentDidMount() {
    this.props.dispatch({ type: 'SubBannerTitle', data: "Ship Staff Management" });
  }

  SubmitData() {
    this.props.dispatch(postStaffInfoList(this.state.StaffInfo));
    this.props.history.push("/Home/Management/Staff");
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.StaffInfo[nodeName] = e.target.value;
    this.setState({});
  }

  render() {

    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="row search-filter-box">
                <div className="col-lg-12">
                  <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                      <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Basic Information</h5>
                    </div>
                  </div>
                  <div className="row search-filter-box">
                    {/* <div className="col-lg-4">
                      <label className="form-label">Ship Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="shipName"
                        placeholder="Ship Name"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.shipName}
                      ></input>
                    </div> */}
                    <div className="col-lg-4">
                      <label className="form-label">Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="Name"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.name}
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">Email</label>
                      <input
                        className="form-control"
                        type="text"
                        name="mail"
                        placeholder="Email"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.mail}
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">Phone</label>
                      <input
                        className="form-control"
                        type="text"
                        name="phone"
                        placeholder="Phone"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.phone}
                      ></input>
                    </div>
                    {/* <div className="col-lg-4">
                      <label className="form-label">Phone 2</label>
                      <input
                        className="form-control"
                        type="text"
                        name="phone2"
                        placeholder="Phone 2"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.phone2}
                      ></input>
                    </div> */}
                    <div className="col-lg-4">
                      <label className="form-label">Address</label>
                      <input
                        className="form-control"
                        type="textarea"
                        name="address"
                        placeholder="Address"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.address}
                      ></input>
                    </div>
                  </div>
                  <div className="row py-3">
                    <div className="col-lg-12">
                      <div className="search-btn-col" style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit" onClick={() => this.SubmitData()}>Submit
                      </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button" onClick={() => this.CancelAdd()}> {" "} Cancel{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  CancelAdd = () => {
    this.props.history.push("/Home/Management/Staff");
  }
}
function mapStateToProps(state) {
  return {

  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StaffManagementAdd);
